<template>
  <div class="InventoryWrapper">
    <div class="Inventory">
      <div class="InventoryInfo">
        <ConditionLabel :status="rank" />
        <div class="PriceLabel">
          <div class="Price">
            {{ inventory.selling_price.toLocaleString() }}
          </div>
          <div class="PriceUnit">円</div>
        </div>
        <div class="InventoryNum">
          在庫：{{ inventory.inventory_num }}
        </div>
      </div>

      <Select
        :options="inventoryNumOptions"
        :placeholder="''"
        emit-number-type
        :modelValue="modelValue"
        @update:modelValue="handleChange"
        class="InventoryNumForm"
        :label="`状態${rank}在庫`"
        :error="hasError || hasNumLimitError"
      />
    </div>
    <ErrorText v-if="hasNumLimitError" text="カート内と合わせて在庫数超えのため追加できません"/>
  </div>
</template>

<script lang="ts">
import { defineNuxtComponent } from '#app'
import { Select, ErrorText, ConditionLabel } from '@ka-nabellinc/ka-nabell-ui'
import type { SelectOption } from "@ka-nabellinc/ka-nabell-ui/src/components/Select";
import type { ShopInventory } from '@ka-nabellinc/tcg-platform-es-schema'
import { computed } from 'vue'
import type { Rank } from '@/types/product'

export default defineNuxtComponent({
  components: {
    Select,
    ErrorText,
    ConditionLabel
  },
  props: {
    rank: {
      type: String as () => Rank,
      required: true
    },
    inventory: {
      type: Object as () => ShopInventory,
      required: true
    },
    numInCart: {
      type: Number,
      required: true
    },
    modelValue: {
      type: Number,
      default: 0
    },
    hasError: {
      type: Boolean,
      default: false
    }
  },
  emits: {
    'update:modelValue': (val: number) => true
  },
  setup(props, { emit }) {
    const inventoryNumOptions = computed<SelectOption[]>(() => {
      const options = new Array(props.inventory.inventory_num)
        .fill(null)
        .map((_, i) => ({ text: String(i + 1), value: i + 1 }));

      return [{ text: "0", value: 0 }, ...options];
    });
    const hasNumLimitError = computed(() => (props.numInCart + props.modelValue) > props.inventory.inventory_num)

    const handleChange = (val: number) => {
      emit('update:modelValue', val)
    }

    return {
      inventoryNumOptions,
      handleChange,
      hasNumLimitError
    }
  }
})
</script>

<style scoped>
.InventoryWrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.Inventory {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.InventoryInfo {
  display: flex;
  flex-direction: column;
}

.PriceLabel {
  display: flex;
  align-items: flex-end;
  gap: 4px;
}

.Price {
  font-size: 15px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: 0.3px;
}

.PriceUnit {
  font-size: 11px;
  line-height: 160%;
  letter-spacing: 0.11px;
}

.InventoryNum {
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0.12px;
}

.InventoryNumForm{
  width: 63px;
}
</style>
